export const formValidationRules = {
  name: [
    (v: any) => !!v || 'Name is required!'
  ],
  duration: [
    (v: any) => !!v || 'Duration is required!'
  ]
}
